import alimTalkTemplate from './alimTalkTemplate';
import charge from './charge';
import common from './common';
import dashboard from './dashboard';
import departmentInformation from './departmentInformation';
import kakaoProfile from './kakaoProfile';
import login from './login';
import messageUsageJourney from './messageUsageJourney';
import mfaSetting from './mfaSetting';
import outgoingPhone from './outgoingPhone';
import profile from './profile';
import rejectPhone from './rejectPhone';
import rejectPhoneData from './rejectPhoneData';
import image from './image';
import validation from './validation';
import category from './category';
import terms from './terms';
import privacy from './privacy';
import versionPanel from './versionPanel';
import resultCodes from './resultCodes';

export default {
  empty: '',
  common,
  alimTalkTemplate,
  charge,
  dashboard,
  departmentInformation,
  kakaoProfile,
  login,
  messageUsageJourney,
  mfaSetting,
  outgoingPhone,
  profile,
  rejectPhone,
  rejectPhoneData,
  image,
  validation,
  category,
  terms,
  privacy,
  versionPanel,
  resultCodes,

  $vuetify: {
    open: '열기',
    close: '닫기',
    pagination: {
      ariaLabel: {
        root: 'Pagination Navigation',
        next: '다음 페이지',
        previous: '이전 페이지',
        page: '{0} 페이지로 이동',
        currentPage: '현재 페이지, 페이지 {0}',
        first: '첫 페이지',
        last: '마지막 페이지',
      },
    },
    noDataText: '검색 결과가 없습니다.',
    dataIterator: {
      loadingText: '로딩 중',
    },
  },
};
